<h1 class="title">Custom Recurrence</h1>

<button class="close-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>

<div class="details-page-edit-form">
  <form [formGroup]="recurrenceForm">
    <rkt-form [form]="recurrenceForm" [fields]="recurrenceFormFields" [model]="recurrenceFormModel"></rkt-form>
  </form>

  @if (formError) {
    <div class="details-page-edit-form-error">{{ formError }}</div>
  }

  <div class="buttons">
    <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
    <button rktButton type="submit" (click)="onSave()" [disabled]="isDisabled" title="Save">Save</button>
  </div>
</div>
